export default class SoundFeedback {
  constructor(sidebarElement) {
    this.active = false;
    this.sidebar = sidebarElement;
    this.handlers = null;
    this.audioContext = null;
  }

  enable() {
    if (this.active) return;
    this.active = true;

    const play = (freq) => this.playTone(freq, 0.06);
    let lastHover = 0;

    const clickHandler = (e) => {
      if (this.sidebar.contains(e.target)) return;
      play(180);
    };
    const focusHandler = (e) => {
      if (this.sidebar.contains(e.target)) return;
      play(260);
    };
    const hoverHandler = (e) => {
      if (this.sidebar.contains(e.target)) return;
      const now = Date.now();
      if (now - lastHover < 200) return;
      lastHover = now;
      play(140);
    };

    document.addEventListener('click', clickHandler);
    document.addEventListener('focusin', focusHandler);
    document.addEventListener('mouseover', hoverHandler);
    this.handlers = { clickHandler, focusHandler, hoverHandler };
  }

  disable() {
    if (!this.active) return;
    if (this.handlers) {
      document.removeEventListener('click', this.handlers.clickHandler);
      document.removeEventListener('focusin', this.handlers.focusHandler);
      document.removeEventListener('mouseover', this.handlers.hoverHandler);
    }
    this.handlers = null;
    this.active = false;
  }

  playTone(freq, duration) {
    if (!this.audioContext) {
      this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
    }
    const ctx = this.audioContext;
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.value = freq;
    gain.gain.value = 0.05;
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.start();
    osc.stop(ctx.currentTime + duration);
  }
}
